import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import { DocumentListReq, DocumentListResp } from "../../../types/files";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminContentApi {
  getContentList(logSearchOptions: DocumentListReq): Promise<DocumentListResp>;
  deleteDocNow(syncId: string[]): void;
  restoreDoc(syncId: string[]): void;
}

class AdminContentServerApi implements AdminContentApi {
  async getContentList(
    logSearchOptions: DocumentListReq
  ): Promise<DocumentListResp> {
    const resp = await axiosAdmin.post<DocumentListResp>(
      `${GATEWAY_URL}/wapi/admins/contents/list`,
      logSearchOptions
    );
    return Promise.resolve(resp.data);
  }
  async deleteDocNow(syncIds: string[]): Promise<void> {
    const resp = await axiosAdmin.post<void>(
      `${GATEWAY_URL}/wapi/admins/contents/delete/now`,
      { syncIds }
    );
    return Promise.resolve(resp.data);
  }
  async restoreDoc(syncIds: string[]): Promise<void> {
    const resp = await axiosAdmin.post<void>(
      `${GATEWAY_URL}/wapi/admins/contents/restore`,
      { syncIds }
    );
    return Promise.resolve(resp.data);
  }
}
const adminContentApi: AdminContentApi = new AdminContentServerApi();
export default adminContentApi;
